import { Injectable } from '@angular/core';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Injectable({
  providedIn: 'root'
})
export class ValidateEmailService {

  constructor(private toastHandlerService: ToastHandlerService) { }

  validateEmailsImport(email: string): boolean {
    if (email == null) return false;
    if (email.length > 250) return false;
    let position: number;
    //Elimino los espacios al inicio y final
    email = email.replace(/\s/g, '');
    //Elimino los espacios entre correos
    const parts = email.split(' ');
    email = parts.join('');
    //Busco la posición de la ";" para reemplazarlo por ","
    position = email.indexOf(";")
    if (position != -1) {
      do {
        email = email.replace(";", ",");
        position = email.indexOf(";")
      }
      while (position > 0);
    }

    //Expresión regular para validar el correo
    // eslint-disable-next-line no-useless-escape
    const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (email) {
      //1.Busco la posición de la "," para verificar si hay más correos
      position = email.indexOf(",")
      //2. Si el resultado es -1 solo hay un correo
      if (position == -1) {
        //3. Verifico si el correo es válido
        if (!emailRegex.test(email)) return false;
        else return true;
      } else {
        do {
          //1. Busco la posición final de la coma
          const endPosition = email.indexOf(",")
          //2.Tomo el primer correo
          const newEmail = email.slice(0, endPosition)

          //3.Verifico si el correo es válido
          if (!emailRegex.test(newEmail)) return false;
          //4. Creo la lista con los correos faltantes
          email = email.slice(endPosition + 1)
          //5. Busco la posición de la "," para verificar si hay más correos
          position = email.indexOf(",")
          //6. Si el resultado es -1 solo hay un correo
          if (position == -1) {
            if (email != '') {
              if (!emailRegex.test(email)) return false;
            } else {
              return false;
            }
          }

        }
        while (position > 0);
      }
    }
    return true;
  }


  validateEmails(email: string): boolean {
    if (email == null) return true;
    let position: number;
    //Busco la posición de la ";" para reemplazarlo por ","
    position = email.indexOf(";")
    if (position != -1) {
      do {
        email = email.replace(";", ",");
        position = email.indexOf(";")
      }
      while (position > 0);
    }

    //Expresión regular para validar el correo
    // eslint-disable-next-line no-useless-escape
    const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (email) {
      //1.Busco la posición de la "," para verificar si hay más correos
      position = email.indexOf(",")
      //2. Si el resultado es -1 solo hay un correo
      if (position == -1) {
        //3. Verifico si el correo es válido
        if (!emailRegex.test(email)) {
          this.toastHandlerService.showToast(
            'warning',
            `El correo "${email}" no es válido. Verifique que el correo se encuentre escrito de forma correcta y que no tenga espacios después de la coma(,) o punto y coma(;).`, 'Atención.');
          return false;
        } else {
          return true;
        }
      } else {
        do {
          //1. Busco la posición final de la coma
          const endPosition = email.indexOf(",")
          //2.Tomo el primer correo
          const newEmail = email.slice(0, endPosition)

          //3.Verifico si el correo es válido
          if (!emailRegex.test(newEmail)) {
            this.toastHandlerService.showToast(
              'warning',
              `El correo "${email}" no es válido. Verifique que el correo se encuentre escrito de forma correcta y que no tenga espacios después de la coma(,) o punto y coma(;).`
            );
            return false;
          }
          //4. Creo la lista con los correos faltantes
          email = email.slice(endPosition + 1)
          //5. Busco la posición de la "," para verificar si hay más correos
          position = email.indexOf(",")
          //6. Si el resultado es -1 solo hay un correo
          if (position == -1) {
            if (email != '') {
              if (!emailRegex.test(email)) {
                this.toastHandlerService.showToast(
                  'warning',
                  `El correo "${email}" no es válido. Verifique que el correo se encuentre escrito de forma correcta y que no tenga espacios después de la coma(,) o punto y coma(;).`
                );
                return false;
              }
            } else {
              this.toastHandlerService.showToast(
                'warning',
                `El correo "${email}" no es válido. Verifique que el correo se encuentre escrito de forma correcta y que no tenga espacios después de la coma(,) o punto y coma(;).`
              );
              return false;
            }
          }

        }
        while (position > 0);
      }
    }
    return true;
  }
}
